import { DateTime } from 'luxon';
import type { DateRangeObject } from 'shared/types/analytics';

/** Years before it come from a date still being typed ("0202" on the way to "2026"). */
const EARLIEST_CHOSEN_YEAR = 1900;

function toChosenDate(isoDate: string): DateTime | undefined {
  const date = DateTime.fromISO(isoDate);
  return date.isValid && date.year >= EARLIEST_CHOSEN_YEAR ? date : undefined;
}

/**
 * Whether a range picked in the date picker can filter the charts: both days
 * chosen, fully typed and in order. Anything else is still being picked.
 */
export function isCompleteDateRange(range: DateRangeObject): boolean {
  const from = toChosenDate(range.from);
  const to = toChosenDate(range.to);
  return from !== undefined && to !== undefined && from <= to;
}
